/*
  It is a base API class which provides common helper methods
  or share common data to its child classes
*/

import { baseUrl } from '../constants'
export default class BaseApi {
  static requestHeaders(contentType='application/json') {
    const basicHeaders = {
      'Content-Type': contentType,
      'access-token': localStorage.getItem('access-token'),
      'token-type': localStorage.getItem('token-type'),
      'client': localStorage.getItem('client'),
      'expiry': localStorage.getItem('expiry'),
      'uid': localStorage.getItem('uid')
    }

    // There might be a case where we do not need 'Content-Type' header
    // For example image upload. check PublicationApi.createCoverPromise method
    // So delete content type if it is `false`
    if(!contentType) { delete basicHeaders['Content-Type'] }

    return new Headers(basicHeaders)
  }

  static buildRequest(endPoint, options={}) {
    let _self = BaseApi;
    let defaultOptions = {headers: _self.requestHeaders(options.contentType)}
    let newOptions = Object.assign({}, options, defaultOptions);
    endPoint = baseUrl.concat(endPoint);

    return new Request(endPoint, newOptions);
  }

  static getResponse(request) {
    return fetch(request).then(response => {
      return response.json();
    }).catch(error => {
      return error;
    })
  }
}



// WEBPACK FOOTER //
// ./src/shared/javascripts/api/BaseApi.js